import * as actionTypes from "./AiKeywordsTypes";

const INTIAL_STATE = {
    AiKeywordsdata: null,
    isLoadingAiKeywords: false,
    isLoadingSaveAiKeywords: false,
    saveAiKeywordsdata: null,
};
const AiKeywordsReducer = (state = INTIAL_STATE, action) => {
    const { payload } = action;
    switch (action.type) {

        case actionTypes.IS_LOADING_AIKEYWORDS:
            return {
                ...state,
                isLoadingAiKeywords: true
            };

        case actionTypes.AIKEYWORDS_DATA_SUCCESS:
            return {
                ...state,
                AiKeywordsdata: payload,
                isLoadingAiKeywords: false,

            };

        case actionTypes.AIKEYWORDS_DATA_FAILED:
            return {
                ...state,
                isLoadingAiKeywords: false
            };
        //////////////////////////////////////////////////////////
        case actionTypes.IS_LOADING_SAVE_AIKEYWORDS:
            return {
                ...state,
                isLoadingSaveAiKeywords: true
            };
        case actionTypes.SAVE_AIKEYWORDS_DATA_SUCCESS:
            return {
                ...state,
                saveAiKeywordsdata: payload,
                isLoadingSaveAiKeywords: false,

            };
        case actionTypes.SAVE_AIKEYWORDS_DATA_FAILED:
            return {
                ...state,
                isLoadingSaveAiKeywords: false
            };

        default:
            return state;
    }
};

export default AiKeywordsReducer;
